const VapiAssistantIcon = ({ isSpeaking }) => {
  const basePath = `${window.location.origin}/images`;
  return (
    <img
      src={
         `${basePath}/vapi-voice-assistant.png`
      }
      alt="Vapi Assistant"
      style={{ width: 21, height: 21}}
    />
  );
};

export default VapiAssistantIcon;
